import { Link } from "react-router-dom";

export default function Unauthorized() {
  return (
    <div className="mt-10 p-6">
      <h1 className="text-3xl font-bold text-red-600">Unauthorized</h1>
      <p className="mt-2 text-sm text-gray-600">You do not have permission to view this page.</p>
      <Link to="/admin" className="mt-4 inline-block text-brand-500">Go back to Dashboard</Link>
    </div>
  );
}
